import React from 'react';
import { withRouter } from 'react-router';
import { compose } from 'recompose';
import {
  map,
} from 'lodash';
import {
  Divider,
  Grid,
  Label,
  Responsive,
  Icon,
} from 'semantic-ui-react';

import { authService } from '../../utils/auth-service';
import hasUserInfo from '../../hocs/has-user-info';
import hasJSONAPIClient from '../../hocs/has-jsonapi-client';
import InfluencerCardPreview from '../../components/influencer-card-preview';

class NewInfluencerWelcome extends React.Component {
  constructor() {
    super();
    this.state = {};
  }
  componentDidMount() {
    this.loadInfluencer();
  }
  loadInfluencer = () => {
    const profile = authService.getProfile();
    const organisationId = profile.app_metadata.dyzio.o_id;

    const { jsonAPIClient } = this.props;
    jsonAPIClient.get('organisations', organisationId, { include: ['influencer'] })
      .then(organisation => organisation.toJSONTree())
      .then(org => {
        const { influencer } = org;
        this.setState({
          influencer,
        });
      })
      .catch(e => {
        console.log(e);
      });
  }
  render() {
    const { influencer } = this.state;
    const {
      name,
      country,
      email,
      instagram, facebook, twitter, youtube,
      web,
      contentTags, previousClients, willNotWorkWith,
    } = influencer || {};
    if (!influencer) return null;
    const { setupComplete } = influencer;
    if (!setupComplete) {
      this.props.history.push('/new-influencer/registration');
      return null;
    }
    return (
      <div>
        <h1>Thankyou for registering</h1>

        <Divider hidden />

        <p>
          Please see below the information that you submitted.
          If you would like to update this information please
          <a href="/new-influencer/registration"> click here</a>.
        </p>
        <br />
        <p>
          {'We\'ll be in contact when we find a brief that we think will be good for you.'}
        </p>

        <Divider hidden />
        <h2>Your profile <a href="/new-influencer/registration"><Icon name="edit" /></a></h2>
        <Divider hidden />
        <Grid>
          <Grid.Row>
            <Grid.Column width={10}>
              <Grid stackable >
                <Grid.Row>
                  <Grid.Column width={8}>
                    <h3>Name</h3>
                    {name}
                  </Grid.Column>
                  <Grid.Column width={8}>
                    <h3>Country</h3>
                    {country}
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={8}>
                    <h3>Email Address</h3>
                    {email}
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  {instagram && (<Grid.Column width={8}>
                    <h3>Instagram</h3>
                    {instagram}
                  </Grid.Column>)}
                  {facebook && (<Grid.Column width={8}>
                    <h3>Facebook</h3>
                    {facebook}
                  </Grid.Column>)}
                  {youtube && (<Grid.Column width={8}>
                    <h3>Youtube</h3>
                    {youtube}
                  </Grid.Column>)}
                  {twitter && (<Grid.Column width={8}>
                    <h3>Twitter</h3>
                    {twitter}
                  </Grid.Column>)}
                </Grid.Row>
                {web && <Grid.Row>
                  <Grid.Column width={5}>
                    <h3>Name</h3>
                    {name}
                  </Grid.Column>
                </Grid.Row>}
                <Grid.Row>
                  {contentTags && <Grid.Column width={8}>
                    <h3>Content Tags</h3>
                    {map(contentTags, ({ value }) => <Label>{value}</Label>)}
                  </Grid.Column>}
                  {previousClients && <Grid.Column width={8}>
                    <h3>Previous Clients</h3>
                    {map(previousClients, ({ value }) => <Label>{value}</Label>)}
                  </Grid.Column>}
                </Grid.Row>
                <Grid.Row>
                  {willNotWorkWith && <Grid.Column width={8}>
                    <h3>Sectors & Brands you will not work for</h3>
                    {map(willNotWorkWith, ({ value }) => <Label key={value}>{value}</Label>)}
                  </Grid.Column>}
                </Grid.Row>
              </Grid>
            </Grid.Column>
            <Responsive width={6} as={Grid.Column} minWidth={768}>
              {influencer && (<InfluencerCardPreview {...influencer} />)}
            </Responsive>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

export default compose(
  withRouter,
  hasJSONAPIClient,
  hasUserInfo,
)(NewInfluencerWelcome);



/** WEBPACK FOOTER **
 ** ./src/containers/new-influencer-welcome/index.js
 **/